import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export function RemoteSupport() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="soporte-remoto" className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(0,255,240,0.05),transparent_60%)]"></div>
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className={`order-2 lg:order-1 text-center lg:text-left anim-fade-left ${isVisible ? 'visible' : ''}`}>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-neon-400/10 border border-neon-400/20 rounded-full mb-6">
              <i className="ri-remote-control-line text-neon-400 text-lg"></i>
              <span className="text-sm text-neon-400 font-medium">Asistencia en tiempo real</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              <strong className="text-neon-400 text-neon-glow-sm">Soporte Técnico</strong> Remoto
            </h2>
            <p className="text-lg text-gray-300 mb-4 leading-relaxed">
              Solución efectiva para tus dispositivos
            </p>
            <p className="text-base text-gray-400 mb-10 leading-relaxed max-w-lg mx-auto lg:mx-0">
              Conectate con nuestros técnicos de forma inmediata y segura. Resolvemos tus problemas informáticos sin necesidad de traslados, desde cualquier lugar.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="https://anydesk.com/es"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-neon-500 to-neon-600 hover:from-neon-400 hover:to-neon-500 text-white hover:text-rosa-400 font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-neon hover:shadow-neon-lg whitespace-nowrap cursor-pointer text-sm sm:text-base border-2 border-cyan-400/60 btn-magnetic"
              >
                <i className="ri-download-cloud-line text-2xl"></i>
                <span>Soporte Técnico Remoto</span>
                <i className="ri-arrow-right-line text-xl transform group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
            <div className="mt-6 flex items-center gap-2 text-gray-500 text-sm justify-center lg:justify-start">
              <i className="ri-shield-check-line text-neon-400"></i>
              <span>Conexión segura y encriptada integrarse con nuestros Software Anydesk</span>
            </div>
          </div>

          <div className={`order-1 lg:order-2 relative anim-fade-right ${isVisible ? 'visible' : ''}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-neon border border-neon-400/20 hover-lift">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20remote%20IT%20support%20technician%20helping%20client%20through%20computer%20screen%20dark%20modern%20office%20with%20multiple%20monitors%20showing%20remote%20desktop%20connection%20cyan%20neon%20ambient%20lighting%20high%20quality%20corporate%20tech%20photography&width=600&height=450&seq=50&orientation=landscape"
                alt="Soporte técnico remoto - Asistencia informática a distancia STI"
                title="Soporte técnico remoto profesional - STI Servicio Técnico Informático"
                width="600"
                height="450"
                className="w-full h-[300px] sm:h-[450px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950/40 to-transparent"></div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-40 h-40 bg-neon-400/10 border border-neon-400/20 rounded-2xl -z-10 neon-border-animate"></div>
          </div>
        </div>
      </div>
    </section>
  );
}